import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Invoice } from '~hooks/useInvoices/models';

import { FlexColumn } from '../../styled';

interface TruckTypeColumnProps {
  invoice: Invoice;
  sx?: SxProps<Theme>;
}

const TruckTypeColumn = ({ invoice, sx }: TruckTypeColumnProps) => {
  const { equipmentTypeNames } = invoice;

  return (
    <Box sx={sx}>
      <FlexColumn>
        <OverflowAwareText fontSize="inherit">
          {equipmentTypeNames.join(', ') || '-'}
        </OverflowAwareText>
      </FlexColumn>
    </Box>
  );
};

export default TruckTypeColumn;
